import { useEffect, useState } from 'react';
import { ITicker } from '@kattana-io/common';
import Text from '../../../atoms/Text';
import PairIcons from '../../../molecules/PairIcons';
import PairsTable from '../../../components/SEO/mobile/PairsTable';
import { ColumnNames } from '../../../components/Modal/TickersModal/columns';
import ExchangeIcon from '../../../components/Modal/TickersModal/ExchangeIcon';
import TableContractField from '../../../components/TableComponents/Contract';
import { switchCurrentTicker } from '../../../Authlogic';
import {
  formatMobileTableData,
  IMobileTableScema,
} from '../../../helpers/formatters';
import { getMobileTokenTableData } from '../helpers';

interface IPairsTableProps {
  title: string;
  pairs?: ITicker[];
}

const TokenMobilePairsTable = ({ title, pairs }: IPairsTableProps) => {
  const [tableData, setTableData] = useState<
    Record<ColumnNames, string | ITicker>[]
  >([]);

  useEffect(() => {
    if (pairs && pairs.length > 0) {
      setTableData(getMobileTokenTableData(pairs));
    }
  }, [pairs]);

  const schema: IMobileTableScema = {
    row_1: {
      item_1: {
        name: 'Source',
        accessor: ColumnNames.exchange,
        parser: (value) => (
          <ExchangeIcon
            textProps={{
              className: 'text--weight-500 text--grey-200',
              size: 14,
              style: {
                display: 'inline-block',
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
              },
            }}
            imageProps={{
              style: {
                order: -1,
                marginRight: 6,
                width: 20,
                height: 20,
              },
            }}
            exchange={value}
          />
        ),
        width: 90,
      },
      item_2: {
        name: 'Pair',
        accessor: ColumnNames.pair,
        parser: (item) => (
          <div className='ticker__cell'>
            <PairIcons
              chain={item.chain}
              pair={item.name}
              base_address={item.base_address}
              quote_address={item.quote_address}
              base_slug={item.base_slug}
              quote_slug={item.quote_slug}
            />
            <Text size={14} className='text--weight-500 text--grey-400'>
              {item.name}
            </Text>
          </div>
        ),
        onClick: (row) => switchCurrentTicker(row[ColumnNames.pair]),
      },
    },
    row_2: {
      item_1: {
        name: 'Price',
        accessor: ColumnNames.price,
        width: 90,
      },
      item_2: {
        name: 'Liquidity',
        accessor: ColumnNames.liquidity,
      },
    },
    row_3: {
      item_1: {
        name: 'Volume',
        accessor: ColumnNames.volume,
        width: 90,
      },
      item_2: {
        name: 'APY',
        accessor: ColumnNames.apy,
      },
    },
    row_4: {
      item_1: {
        name: 'Contract',
        accessor: ColumnNames.contract,
        parser: (value) => (
          <TableContractField
            address={value.address}
            chain={value.chain || ''}
            textSize={14}
          />
        ),
      },
    },
  };

  const parsedData = formatMobileTableData({
    data: tableData,
    schema,
    getColorForItem: () => 'grey',
  });

  return <PairsTable title={title} data={parsedData} />;
};

export default TokenMobilePairsTable;
